import React from 'react';

import CustomButton from '../atoms/CustomButton';
import { Container } from './PageListHeaderStyle';
import { Flex, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;
const PageInnerHeader = ({ title, navigatePath }) => {
  const navigate = useNavigate();
  const navigatBack = () => {
    navigate(navigatePath);
  };

  return (
    <Container>
      <Flex justify='space-between' align='center'>
        <Title level={4} style={{ marginBlockStart: '0.33em', marginBlockEnd: '0.33em' }}>
          {title}
        </Title>
        <CustomButton type='primary' ghost size='large' onClick={navigatBack}>
          Back
        </CustomButton>
      </Flex>
    </Container>
  );
};

export default PageInnerHeader;
